import React, { useState } from 'react';
import Inputs from 'components/inputs/inputs';
import UserService from 'services/userService';
import Helpers from 'utils/helpers';

export default function DistributorList(props) {
  const [showSelected, setShowSelected] = useState(true);
  const [showUnselected, setShowUnselected] = useState(true);
  const [showMyself, setShowMyself] = useState(true);
  const { filter, recipientsList, recipientsSelected } = props;
  const myselfValue = UserService.getUserField('contactId');
  let selectedCount = 0;
  let unselectedCount = 0;
  let myselfCount = 0;

  const isTextFilterValid = (!Helpers.String.isEmpty(filter) && filter.length >= 3);
  const textFilterFn = (item) => {
    if (isTextFilterValid &&
      !(item && item.contactName && item.contactName.toLowerCase().indexOf(filter) !== -1) &&
      !(item && item.communicationValue && item.communicationValue.toLowerCase().indexOf(filter) !== -1)) {
      //filter out based on text filter
      return false;
    }
    return true;
  };
  const filteredList = isTextFilterValid ? recipientsList.filter(textFilterFn) : recipientsList;

  const myselfFilterFn = (item) => {
    if (item && item.contactId && item.contactId === myselfValue) {
      myselfCount += 1;
      if (!showMyself) {
        //filter out based on buttons
        return false;
      }
      return true;
    }
    return false;
  };
  const myselfList = filteredList.filter(myselfFilterFn);

  const remainingFilterFn = (item) => {
    if (item && item.contactId && item.contactId === myselfValue) {
      //filter out because myself
      return false;
    }
    const selected = item && item.communicationId && recipientsSelected.find((a) => a === item.communicationId);
    if (selected) {
      selectedCount += 1;
    }
    else {
      unselectedCount += 1;
    }
    if ((!showSelected && selected) || (!showUnselected && !selected)) {
      //filter out based on buttons
      return false;
    }
    return true;
  };
  const remainingList = filteredList.filter(remainingFilterFn);

  const renderRows = (array, isCreateDividers) => {
    if (!array.length) {
      return null;
    }
    let items = [];
    let lastDividerLetter = '';
    for (let i = 0; i < array.length; i++) {
      const item = array[i];
      item.contactName = item.contactName || ' ';
      if (isCreateDividers) {
        const firstLetter = item.contactName[0].toString().toUpperCase();
        if (firstLetter !== lastDividerLetter) {
          lastDividerLetter = firstLetter;
          items.push(<DistributorListDivider text={lastDividerLetter} key={'divider_' + lastDividerLetter} />);
        }
      }

      let name = <span>{item.contactName}</span>;
      let address = <span>{item.communicationValue}</span>;
      if (isTextFilterValid) {
        const nameParts = item.contactName.split(new RegExp(`(${filter})`, 'gi'));
        name = (
          <span>
            {nameParts.map((part, i) =>
              <span className={part.toLowerCase() === filter.toLowerCase() ? 'bg-highlighter' : ''} key={i}>
                {part}
              </span>
            )}
          </span>
        );
        const addressParts = item.communicationValue.split(new RegExp(`(${filter})`, 'gi'));
        address = (
          <span>
            {addressParts.map((part, i) =>
              <span className={part.toLowerCase() === filter.toLowerCase() ? 'bg-highlighter' : ''} key={i}>
                {part}
              </span>
            )}
          </span>
        );
      }

      items.push(
        <DistributorListRow
          key={i}
          id={item.communicationId}
          name={name}
          address={address}
          checked={recipientsSelected.indexOf(item.communicationId) !== -1}
          recipientsSelected={recipientsSelected}
          onChange={props.onChange}
        />
      );
    }
    return items;
  };

  return (
    <>
      <div>
        <h5>Filter</h5>
        <DistributorListFilterTag
          title='Selected'
          variant='success'
          show={showSelected}
          count={selectedCount}
          onClick={() => setShowSelected(!showSelected)}
        />
        <DistributorListFilterTag
          title='Unselected'
          variant='info'
          show={showUnselected}
          count={unselectedCount}
          onClick={() => setShowUnselected(!showUnselected)}
        />
        <DistributorListFilterTag
          title='Myself'
          variant='secondary'
          show={showMyself}
          count={myselfCount}
          onClick={() => setShowMyself(!showMyself)}
        />
      </div>
      <div>
        {
          myselfList && myselfList.length > 0 ?
            <>
              <DistributorListDivider text='Myself' variant='secondary' />
              {renderRows(myselfList, false)}
            </>
            :
            null
        }
        {
          remainingList && remainingList.length > 0 ?
            renderRows(remainingList, true)
            :
            null
        }
      </div>
    </>
  );
}

function DistributorListRow(props) {
  const handleCheckboxChange = (newValue) => {
    let recipients = [];
    if (newValue) {
      recipients = [...props.recipientsSelected, props.id];
    }
    else {
      recipients = props.recipientsSelected.filter((item) => item !== props.id);
    }
    if (props.onChange) {
      props.onChange(recipients);
    }
  };

  const renderLabel = () => {
    return (
      <span>
        {props.name}{' <'}{props.address}{'>'}
      </span>
    );
  };

  return (
    <div className='my-1'>
      <Inputs.Checkbox
        variant='success'
        size='lg'
        label={renderLabel()}
        checked={props.checked}
        onValueChange={handleCheckboxChange}
      />
    </div>
  );
}

function DistributorListDivider(props) {
  const text = Helpers.String.isEmpty(props.text) || props.text === ' ' ? 'Other' : props.text;
  return (
    <div className={'px-4 py-2 my-2 ' + (props.variant ? ('text-light bg-' + props.variant) : 'text-dark bg-default')}>
      <h4 className='py-0 my-0'>{text}</h4>
    </div>
  );
}

function DistributorListFilterTag(props) {
  const isShown = props.show;
  return (
    <span className={'badge badge-lg mb-1 mx-1 badge-light-' + (isShown ? props.variant : 'default')} style={{ cursor: 'pointer' }} onClick={props.onClick}>
      <span className='text-thicker'>{(isShown ? 'Hide ' : 'Show ')}</span> {props.title} ({props.count})
    </span>
  );
}